
import MaintenanceAlert from '@/components/MaintenanceAlert.vue'

export default {
  name: 'ClassLayout',
  components: {
    MaintenanceAlert,
  },
  middleware: 'authentication',
  data() {
    return {
      name: '',
      img: '/img/standardUser.svg',
    }
  },
  computed: {
    user() {
      return this.$store.getters['credential/user']
    },
  },
  async created() {
    const response = await this.$axios.get('/api/v1/academic/customer')
    if (response.data.image) {
      const newImageURL = response.data.image
      this.img = newImageURL
      this.$store.commit('credential/updateImage', newImageURL)
    } else {
      this.$store.commit('credential/updateImage', this.img)
    }
  },
}
